import React from 'react';
import { Mail, Phone, MessageCircle } from 'lucide-react';
import './ContactSection.css';

const ContactSection = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <h2 className="contact-title">Jetzt Kontakt aufnehmen</h2>
        <p className="contact-subtitle">
          Haben Sie Fragen oder möchten Sie ein Angebot erhalten? Kontaktieren Sie uns!
        </p>

        <div className="contact-methods">
          <a href="mailto:kontakt@froststudio.de" className="contact-card">
            <div className="contact-icon">
              <Mail size={32} />
            </div>
            <h3 className="contact-method-title">E-Mail</h3>
            <p className="contact-method-value">kontakt@froststudio.de</p>
            <span className="contact-cta">Nachricht senden →</span>
          </a>

          <a href="tel:01622112584" className="contact-card">
            <div className="contact-icon">
              <Phone size={32} />
            </div>
            <h3 className="contact-method-title">Telefon</h3>
            <p className="contact-method-value">0162 2112584</p>
            <span className="contact-cta">Anrufen →</span>
          </a>

          <a href="https://wa.me/491622112584" target="_blank" rel="noopener noreferrer" className="contact-card">
            <div className="contact-icon">
              <MessageCircle size={32} />
            </div>
            <h3 className="contact-method-title">WhatsApp</h3>
            <p className="contact-method-value">0162 2112584</p>
            <span className="contact-cta">Chat starten →</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
